export default {
    accept_payment: "Төлөмдү кабыл алуу",
    add_new_record: "+ визитти кошуу",
    added: "Кошулду",
    additionally: "Кошумча",
    are_you_sure_want_to_change_time: "Сиз чындыгында визиттин убактысын өзгөрткүңүз келеби?",
    are_you_sure_want_to_move_visit: "Сиз чындыгында визитиңизди жылдыргыңыз келеби?",
    are_you_sure_you_want_to_delete_record: "Сиз чындыгында жазылууну жок кылгыңыз келеби?",
    blocked: "Бөгөттөлгөн",
    by_phone_found: "{phone} телефон номери аркылуу төмөнкү бейтаптар табылган",
    by_phone_nobody_found: "{phone} телефон номери аркылуу бир дагы бейтап табылган жок",
    calendar_settings: "Календар орнотуулары",
    cancel_record: "Жазылууну жок кылуу",
    CHAIR: "Креслолор боюнча",
    change_record: "Жазылууну өзгөртүү",
    checkup: "Текшерүү",
    child_age: "18-ден кичүү",
    choose_all: "Баарын тандоо",
    clear: "Тазалоо",
    confirm_visit: "Визитти тастыктоо",
    create_notification: "Билдирүүнү түзүү",
    create_patient: "Бейтапты түзүү",
    create_task: "Тапшырманы түзүү",
    curation: "Курация",
    DAY: "Бир күнгө",
    day_short: "күн",
    days: "күн",
    delete_record: "Визитти жокко чыгаруу",
    diagnostics: "Диагностика",
    DOCTOR: "Дарыгерлер боюнча",
    doctor_available_time: "Дарыгердин жеткиликтүү убактысы",
    doctor_has_no_available_time_at_this_day: "Бул күнү дарыгер жеткиликтүү эмес.",
    doctor_is_not_working_on_this_date_continue: "Дарыгер бул убакта иштебейт же бул убакта бош эмес. Улантасызбы?",
    doctors_selected: "Тандалган дарыгерлер",
    edit_schedule: "Ырааттаманы өзгөртүү",
    edit_visit: "Визитти өзгөртүү",
    email_text: "Каттын тексти",
    email_topic: "Каттын темасы",
    employees_selected: "Тандалган кызматкерлер",
    fill_treatment: "Дарылоону толтуруу",
    fillDoctorColor: "Жазылууну дарыгердин түсүнө боёңуз",
    for: "үчүн",
    free_minutes: "Бош минута",
    hideChairsWithoutSchedule: "Тандалган күнү жеткиликсиз дарыгерлердин отургучтарын жашыруу",
    hideDoctorsWithoutSchedule: "Тандалган күнү жеткиликсиз дарыгерлерди жашыруу",
    hour_short: "с",
    in_calendar_card_show_first: "Календар карточкасында биринчи көрсөтүү",
    info: "Маалымат",
    load_demo_data_to_account: "Аккаунтка демо-дайындарын жүктөп берүү?",
    min_short: "мин",
    min_shortest: "м",
    MONTH: "Бир айга",
    move_record: "Жазылууну башка күнгө жылдыруу",
    need_to_select_at_least_one_doctor: "Жок дегенде бир дарыгерди тандоо керек",
    need_to_select_at_least_one_employee: "Жок дегенде бир кызматкерди тандоо керек",
    new_visit: "Жаңы визит",
    no_birthdays_on_this_date: "Көрсөтүлгөн датага туулган күн жок",
    no_free_time: "Бош убакыт жок",
    no_schedule: "Ырааттама жок",
    no_visits: "Визит жок",
    not_working: "Иштебейт",
    of_day: "күн",
    online_consultation: "Онлайн кеңеш",
    patient_came: "Бейтап келди",
    patient_card: "Бейтаптын карточкасы",
    patient_comment: "Пациенттин комментарийи",
    patient_notifications: "Бейтапка билдирүү жөнөтүү",
    postponed: "Жылдыруу",
    quick_view: "Тез карап чыгуу",
    record_again: "Кайра жазылуу",
    record_comment: "Комментарийге кириңиз",
    record_conflict: "Жазылуу боюнча конфликт",
    record_has_no_paid_services: "Жазылууда акы төлөнүүчү кызматтар жок",
    record_type: "Жазылуунун түрү",
    related_tasks: "Байланган тапшырмалар",
    requires_confirmation: "Тасыктоо талап кылынат",
    return_visit: "Акыркы визит",
    sanation: "Санация",
    schedule: "Ырааттама",
    select_a_doctor: "Дарыгерди тандаңыз",
    select_an_employee: "Кызматкерди тандаңыз",
    select_assistant: "Жардамчыны тандаңыз",
    selected: "Тандалган",
    send_sms: "SMS жөнөтүү",
    showClientTags: "Бейтаптарды белгилөө түстөрүн колдонуу",
    showDoctorColor: "Дарыгерлердин түстөрүн колдонуу",
    showOverflowScreen: "Чоң маалымат топтомдору менен иштөөдө экранды жылдырууну колдонуңуз",
    showPlannedServices: "Текст менен кызматтарды көрсөтүү",
    showRecordTagColor: "Ярлык түстөрүн визиттин фону катары колдонуу",
    showServiceColor: "Категориялардын түстөрүн колдонуу",
    showStatusColor: "Визиттин статустарынын түстөрүн колдонуу",
    sms_text: "SMS тексти",
    till: "чейин",
    time_has_already_passed: "Убакыт өтүп кетти",
    to_contact: "Байланыш",
    tomorrow: "Эртең",
    visits_count: "Визит жок | визит | визиттин",
    visits_count_much: "визиттер",
    warranty_case: "Кепилдик иши",
    WEEK: "Бир жумага",
    write: "Жаз",
    write_reason_for_cancellation: "Жокко чыгаруунун себебин көрсөтүү",
    yesterday: "Кечээ",
    you_have_no_doctors: "Сизде эч кандай дарыгер жок. Дарыгерди кошсоңуз болот <a href='{href}'>бул жерде</a>"
}
